import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { HOW_PLUS_WORKS_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const HowItWorksModal = (props) => {
    const {
        gotIt,
        howItWorksTitle,
        howItWorksBlock1Title,
        howItWorksBlock1Text,
        howItWorksBlock2Title,
        howItWorksBlock2Text,
        howItWorksBlock3Title,
        howItWorksBlock3Text,
    } = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(HOW_PLUS_WORKS_SCREEN_SHOWN);
    }, []);

    return (
        <ModalComponent hasBottomPanel onCloseIconClick={() => props.toggleModal(false)}>
            <HeaderPanel title={howItWorksTitle} />
            <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                {howItWorksBlock1Title}
            </Text>
            <Text variant="div" indent="48px">
                {howItWorksBlock1Text}
            </Text>
            <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                {howItWorksBlock2Title}
            </Text>
            <Row>
                <Text variant="div" indent="48px">
                    {howItWorksBlock2Text}
                </Text>
            </Row>
            <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                {howItWorksBlock3Title}
            </Text>
            <Row>
                <Text variant="div">{howItWorksBlock3Text}</Text>
            </Row>
            <FixedBottomPanel isRightAligned>
                <Button
                    type="button"
                    raised={true}
                    caption={gotIt}
                    onClick={() => {
                        props.toggleModal(false);
                    }}
                />
            </FixedBottomPanel>
        </ModalComponent>
    );
};

export default connect(null, { toggleModal })(HowItWorksModal);
